/** Normalize collector Mongo ids that Jackson may send as a hex string or ObjectId object. */
export function asCollectorMongoId(raw: unknown): string {
  if (typeof raw === "string") {
    const trimmed = raw.trim();
    if (trimmed && trimmed !== "[object Object]") {
      return trimmed;
    }
    return "";
  }
  if (raw && typeof raw === "object") {
    const rec = raw as Record<string, unknown>;
    if (typeof rec.$oid === "string") return rec.$oid;
    if (typeof rec.hex === "string") return rec.hex;
  }
  return "";
}

export function collectorMongoId(item: { id?: unknown; _id?: unknown } | null | undefined): string {
  if (!item) return "";
  return asCollectorMongoId(item.id) || asCollectorMongoId(item._id);
}

export function itemMatchesRouteId(
  item: { id?: unknown; _id?: unknown; collectorItemId?: string } | null | undefined,
  routeId: string | undefined
): boolean {
  if (!item || !routeId) return false;
  return collectorMongoId(item) === routeId || item.collectorItemId === routeId;
}

export function collectorRecordKey(item: {
  id?: unknown;
  _id?: unknown;
  collectorItemId?: string;
} | null | undefined): string {
  return collectorMongoId(item) || String(item?.collectorItemId || "");
}

/** Absolute URL encoded in printable QRs. Uses the host the collector is on so a phone can open it. */
export function publicPieceUrl(collectorItemId: string, apiUrl?: string): string {
  const id = String(collectorItemId || "").trim();
  if (!id) return "";
  const path = `/my-collection/piece/${id}`;
  const origin = (typeof window !== "undefined" ? window.location.origin : "").replace(/\/$/, "");
  if (apiUrl && /^https?:\/\//i.test(apiUrl)) {
    try {
      const api = new URL(apiUrl);
      const currentHost = origin ? new URL(origin).hostname : "";
      const apiIsLoopback = api.hostname === "localhost" || api.hostname === "127.0.0.1";
      const currentIsLoopback = currentHost === "localhost" || currentHost === "127.0.0.1";
      if (apiIsLoopback && currentHost && !currentIsLoopback) {
        return `${origin}${path}`;
      }
      return `${api.origin}${path}`;
    } catch {
      return origin ? `${origin}${path}` : path;
    }
  }
  return origin ? `${origin}${path}` : path;
}
